import { Dialog, Portal } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { MODAL_SIZES } from 'shared/components/Modal/types';

type ModalProps = {
  children: ReactNode;
  title: string;
  size: MODAL_SIZES;
  open: boolean;
} & Dialog.RootProps;

export const Modal = ({
  children = null,
  size,
  onOpenChange,
  open,
  title,
  ...props
}: ModalProps) => (
  <Dialog.Root
    lazyMount
    open={open}
    size={size}
    placement="center"
    scrollBehavior="inside"
    {...props}
  >
    <Portal>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content
          onWheel={(e: React.WheelEvent<HTMLDivElement>) => {
            e.stopPropagation();
          }}
          onScroll={(e: React.UIEvent<HTMLDivElement>) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {children}
        </Dialog.Content>
      </Dialog.Positioner>
    </Portal>
  </Dialog.Root>
);
